import { Editor } from "@hugerte/hugerte-react";
import { getTags } from "../../Logic/tagSchema";
import { NestedMenuItemSpec } from "hugerte";
import { Editor as hEditor } from "hugerte";
import { useContext, useEffect, useRef, useState } from "react";
import "./styles.css";
import { tenantContext } from "../../Main/contexts";
import { iMailboxConfig } from "../../Logic/config";

type EditorProps = {
    key: string;
    onChange: Function;
    initialValue: string;
    height: string;
    derfaultValues?: iMailboxConfig;
};

function HtmlEditor(props: EditorProps) {
    const [defaultVals, setDefaultVals] = useState(props.derfaultValues);
    useEffect(() => {
        //setFieldValue(props.value);
    }, [props.derfaultValues]);

    function getMenuTags(editor: hEditor): NestedMenuItemSpec {
        const allTags = getTags();
        return {
            type: "nestedmenuitem",
            text: "Tags",
            icon: "addtag",
            getSubmenuItems: () => {
                return allTags.map(c => {
                    return {
                        type: "menuitem",
                        text: c.friendlyName + " " + c.name,
                        onAction: () => editor.insertContent(c.name),
                    };
                });
            },
        };
    }

    const returnData = (editor: hEditor) => {
        //props.onChange(editor.dom.doc.documentElement.outerHTML);
        props.onChange(editor.getContent());
    };

    return (
        <>
            <Editor
                key={props.key}
                onBeforeSetContent={e => {
                    if (e.content) {
                        // Convert plain text newlines to HTML line breaks
                        e.content = e.content.replace(/\r\n\r\n/g, "<p></p><p>");
                        e.content = e.content.replace(/\r\n/g, "<p>");
                    }
                }}
                onEditorChange={(content: any, editor) => {
                    returnData(editor);
                }}
                value={props.initialValue}
                plugins={["link", "image", "table ", "lists", "code"]}
                init={{
                    // newline_behavior: "linebreak",
                    height: props.height,
                    browser_spellcheck: true,
                    toolbar_items_size: "small",
                    block_formats: "Paragraph=p;Heading 2=h2;Heading 3=h3;Heading 4=h4;",
                    contextmenu: "myCustomParent | link image | paste  ",
                    toolbar:
                        " undo redo | formatselect | fontfamily fontsize | bold italic forecolor backcolor | \
                 alignleft aligncenter alignright alignjustify | \
                 bullist numlist outdent indent | removeformate ",
                    //content_css: "/AptosNew/aptos_css.css",
                    font_family_formats:
                        "Aptos='Aptos';Century Gothic=Century Gothic;Andale Mono=andale mono,times; Arial=arial,helvetica; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Oswald=oswald; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                    setup: function (editor) {
                        // Register the nested menu structure
                        editor.ui.registry.addNestedMenuItem("myCustomParent", getMenuTags(editor));
                    },
                    forced_root_block: "p",
                    forced_root_block_attrs: {
                        style: "margin:0px;padding:0px;",
                    },
                    font_size_formats: "6px 7px 8px 9px 10px 11px 12px 13px 14px 15px 16px 18px 24px 36px 48px",
                    content_style:
                        "@import url('/Fonts/AptosNew/aptos_css.css');" +
                        "body{font-family: " +
                        (defaultVals ? defaultVals.defaultFont : "'Century Gothic', sans-serif ") +
                        (defaultVals
                            ? defaultVals.defaultFontSize == undefined
                                ? "; font-size: 13px"
                                : "; font-size:" + defaultVals.defaultFontSize
                            : "; font-size: 13px") +
                        "} p{margin:0px;padding:0px;margin-bottom:0pt;} " +
                        "p.EmsNormal {margin:0px;padding:0px;margin-bottom:0pt;} td {height: 20px  }" +
                        " h2{font-size:24px !important;} " +
                        " h3{font-size:22px !important;} " +
                        " h4{font-size:20px !important;} " +
                        " h5{font-size:18px !important;} " +
                        " h6{font-size:16px !important;} h1{font-size:26px !important;}",
                    style_formats: [
                        { title: "default", inline: "span", styles: { fontSize: "10px", fontWeight: "normal" } },
                        {
                            title: "Heading 1",
                            inline: "span",
                            styles: { fontSize: "26px", fontWeight: "bold", display: "block" },
                        },
                        {
                            title: "Heading 2",
                            inline: "span",
                            styles: { fontSize: "24px", fontWeight: "bold", display: "block" },
                        },
                        {
                            title: "Heading 3",
                            inline: "span",
                            styles: { fontSize: "22px", fontWeight: "bold", display: "block" },
                        },
                        {
                            title: "Heading 4",
                            inline: "span",
                            styles: { fontSize: "20px", fontWeight: "bold", display: "block" },
                        },
                        {
                            title: "Heading 5",
                            inline: "span",
                            styles: { fontSize: "18px", fontWeight: "bold", display: "block" },
                        },
                        {
                            title: "Heading 6",
                            inline: "span",
                            styles: { fontSize: "16px", fontWeight: "bold", display: "block" },
                        },
                    ],
                }}
            />
        </>
    );
}

export default HtmlEditor;
